import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { PAGES_PATH } from "../../../navigation/params";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { usePrequalContinuation } from "../../../hooks/usePrequalContinuation";
import { usePrequalificationInfo } from "../../../services/prequalification";

const FullPageLoader = () => (
  <div className="flex h-full w-full flex-col items-center justify-center">
    <img src="/assets/icons/Foxhound_Loading.gif" className="w-96" alt="Loading" />
  </div>
);

// SMS deep-link landing for purchase continuation (SGPD-475): resolves the
// latest valid prequalification after auth and hands routing to the shared
// continuation hook. URL params are intentionally ignored — the persisted
// record is the single source of truth, keeping SMS/card/CTA entries
// consistent.
const PurchaseContinuationContainer = () => {
  const navigate = useNavigate();
  const { petList } = usePetStore();
  const {
    fetchPrequalificationInfo,
    prequalificationInfo,
    loading,
    error,
  } = usePrequalificationInfo();
  const { continueFromRecord } = usePrequalContinuation({
    source: "prequal_sms_deeplink",
  });
  const startedRef = useRef(false);

  useEffect(() => {
    fetchPrequalificationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error && !prequalificationInfo && !loading) {
      navigate(PAGES_PATH.DASHBOARD, { replace: true });
    }
  }, [error, prequalificationInfo, loading, navigate]);

  useEffect(() => {
    if (startedRef.current) return;
    if (!prequalificationInfo || !petList) return;
    startedRef.current = true;
    continueFromRecord(prequalificationInfo);
  }, [prequalificationInfo, petList, continueFromRecord]);

  return <FullPageLoader />;
};

export default PurchaseContinuationContainer;
